export default __webpack_public_path__ + "static/media/hash.242559c9.svg";